export const UPDATE_ASSETS_GROUPS = `
  mutation Asset($input: UpdateAssetsGroupsInput!) {
    asset {
      updateAssetsGroups(input: $input) {
        success
        message
      }
    }
  }
`;

export const UPDATE_ASSET_ACCOUNTS = `
  mutation Asset($input: UpdateAssetAccountsInput!) {
    asset {
      updateAssetAccounts(input: $input) {
        success
        message
      }
    }
  }
`;

export const FIND_ASSIGNABLE_ASSETS_FOR_ACCOUNT = `
  query FindAssignableAssetsForAccount($filter: FindAssignableAssetsForAccountFilter!, $page: PageRequest) {
    asset {
      findAssignableAssetsForAccount(filter: $filter, page: $page) {
        count
        limit
        offset
        items {
          id
          name
          description
          isGroupAssigned
          groups {
            id
            name
          }
        }
      }
    }
  }
`;

export const FIND_ACCOUNT_ASSIGNMENTS = `
  query FindAccountAssignments($accountId: String!, $workspaceId: String!) {
    account {
      findAccountAssignments(accountId: $accountId, workspaceId: $workspaceId) {
        assets
        groups
      }
    }
  }
`;
